import { VuiFormItem, VuiSelectSingle } from "../../../../@vendor/components";
import { ICounselingForm } from "../interface";
import { useTranslation } from "react-i18next";
import CounselingFormLabel from "../Label";

const CounselingFormDropdown = ({ question }: ICounselingForm) => {
  const { t } = useTranslation();

  return (
    <VuiFormItem
      rules={[
        {
          required: question.is_required,
          message: t("validation.required", {
            item: question.question,
          }),
        },
      ]}
      name={String(question.id)}
      label={
        <CounselingFormLabel
          label={question.question}
          isRequired={question.is_required}
        />
      }
    >
      <VuiSelectSingle
        defaultOptions={question.answers.map((answer) => ({
          id: answer,
          name: answer,
        }))}
      />
    </VuiFormItem>
  );
};

export default CounselingFormDropdown;
